import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import { DashboardDates } from '../models';


const KEY_ACTION = ActionType.GetDashboardDatesRequest;
const ACTIONS    = [
  ActionType.GetDashboardDatesRequest,
  ActionType.GetDashboardDatesResponse,
  ActionType.GetDashboardDatesError,
];


type Payload = DashboardDates;


type Meta = {
  clientId: number;
  assessmentId: number;
};


/**
 * Dispatch this action to retrieve the scores associated with a particular release of a particular feedback report
 *
 * @param userClientId - the client id for the currently logged in user
 */
export const getDashboardDatesAction = (
  userClientId: number,
  clientId: number,
  assessmentId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.GetDashboardDates,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      userClientId,
      clientId,
      assessmentId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { clientId, assessmentId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${clientId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const { clientId } = action.meta;
  const { assessmentId } = action.meta;

  const metaTag       = `${clientId}.${assessmentId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  if (!payload) {
    return successState;
  }

  return R.assocPath(
    ['dashboardDates'],
    payload,
    successState,
  );
};

export const getDashboardDatesReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
